import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import { Panel } from '../../../common/panel'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { selectOwnershipStructure } from '../store/slice'
import {
  downloadStructureMajorShareholder,
  getOwnershipTypes,
} from '../store/thunk'
import { GroupPieChart } from './GroupPieChart'
import { OwnershipStructureTable } from './OwnershipStructureTable'
import { PopupOSHistory } from './PopupOSHistory'

export const OwnershipStructure = ({ organizationId }) => {
  const dispatch = useDispatch()

  const ownershipStructure = useSelector(selectOwnershipStructure)
  const locale = useSelector((state) => state.i18n.locale)
  const label = UseI18n('companyAnalysis.ownershipAndGroup.OWNERSHIP_STRUCTURE')
  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)

  const [isOpenPopupHistorical, setIsOpenPopupHistorical] = useState(false)

  const onOpenPopupHistorical = () => {
    setIsOpenPopupHistorical(true)
  }

  const onClosePopupHistorical = () => {
    setIsOpenPopupHistorical(false)
  }

  useEffect(() => {
    dispatch(getOwnershipTypes())
  }, [locale])

  return (
    <Panel
      isI18n
      label={label}
      downloadJpgParams={{
        disabled: !Object.keys(ownershipStructure).length,
        arrName: [
          label,
          organizationShortName || organizationName || taxCode || '',
        ],
        domId: 'ownershipStructure',
        titleJpg: label,
      }}
      downloadCsv={{
        disabled: !Object.keys(ownershipStructure).length,
        downloadFunc: () =>
          downloadStructureMajorShareholder({
            OrganizationId: organizationId,
          }),
      }}
    >
      {Object.keys(ownershipStructure).length ? (
        <>
          <div id="ownershipStructure">
            <GroupPieChart />
          </div>
          <Element className="px2 py1 dFlex justifyContentEnd">
            <Element
              elementName="span"
              className="cursorPointer wFitContent"
              style={{ color: '#2C73E8' }}
              onClick={onOpenPopupHistorical}
            >
              <Translate value="companyAnalysis.ownershipAndGroup.SHOW_HISTORICAL_OWNERSHIP" />
            </Element>
          </Element>
          <OwnershipStructureTable />
          {isOpenPopupHistorical && (
            <PopupOSHistory onClose={onClosePopupHistorical} />
          )}
        </>
      ) : (
        <div className="p1">
          <Notification value="companyAnalysis.ownershipAndGroup.OWNERSHIP_STRUCTURE_NO_DATA" />
        </div>
      )}
    </Panel>
  )
}
